import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'REFERRAL_UPDATE',
    smsDelete : 'REFERRAL_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        subscriber: [],
        subscriber_count: null,
        subscriberLoading: false,
        subscriberError: false,

        referral: [],
        referralCount: null,
        submitSuccess: false,
        referralLoading: false,
        referralError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_SUBSCRIBER(state, {results, count}) {
            state.subscriber = results.data;
            state.subscriber_count = count;
        },

        SUBSCRIBER_LOADING (state, loading) {
            state.subscriberLoading = loading;
        },

        SUBSCRIBER_ERROR (state, hasError) {
            state.subscriberError = hasError;
        },

        SET_REFERRAL(state, {results, count}) {
            state.referral = results.data;
            state.referralCount = count;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        REFERRAL_LOADING (state, loading) {
            state.referralLoading = loading;
        },

        REFERRAL_ERROR (state, hasError) {
            state.referralError = hasError;
        }
    },

    actions: {
        async fetchReferralUser({ commit }, payload) { 
            commit('SUBSCRIBER_LOADING', true);
            commit('SUBSCRIBER_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.search) params.append('search', payload.search);

                let url = V1API.referral_user_list + '?' + params.toString();
                let result = await axios.get(url, config);
                const {results, count} = result.data
                commit('SET_SUBSCRIBER', {results, count});
                return result
            } catch(error) {
                commit('SUBSCRIBER_ERROR', true);
            } finally {
                commit('SUBSCRIBER_LOADING', false);
            }
        },

        async addReferral ({commit, dispatch}, payload) {
            commit('REFERRAL_LOADING', true);
            commit('REFERRAL_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_referral, payload.referral, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchReferral', {
                    perPage: 20,
                    currentPage: 1
                })
                return response

            } catch (e) {
                commit('REFERRAL_ERROR', true);
            } finally {
                commit('REFERRAL_LOADING', false);
            }
        },

        async fetchReferral ({ commit }, payload) {
            commit('REFERRAL_LOADING', true);
            commit('REFERRAL_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);

                let url = V1API.referral_list + '?' + params.toString();
                let result = await axios.get(url, config);
                const {results, count} = result.data
                commit('SET_REFERRAL', {results, count});
                return result
            } catch(error) {
                commit('REFERRAL_ERROR', true);
            } finally {
                commit('REFERRAL_LOADING', false);
            }
        },

        async updateReferral ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_referral + payload.id, payload.referral, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchReferral', {
                    perPage: payload.perPage || 20,
                    currentPage: payload.currentPage || 1
                })
                return response

            } catch (e) {
                commit('REFERRAL_ERROR', true);
            } finally {
                commit('REFERRAL_LOADING', false);
            }
        },

        async updateReferralStatus ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.get(V1API.update_referral_toggle + payload.toggle_id, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchReferral', {
                    perPage: payload.perPage || 20,
                    currentPage: payload.currentPage || 1
                })
                return response

            } catch (e) {
                commit('REFERRAL_ERROR', true);
            } finally {
                commit('REFERRAL_LOADING', false);
            }
        },
        
        async deleteReferral({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.referral_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchReferral', {
                perPage: payload.perPage || 20,
                currentPage: payload.currentPage || 1
            })
            return response
        }
    },

    getters: {}
}
